import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

export const InfoModal = ({ isOpen, handleClose }) => {
  return (
    <BaseModal title="Cómo jugar" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-700 dark:text-gray-300">
        Tenés 6 intentos para adivinar la palabra tucumana del día. después de cada
        intento, el color de las teclas se modificará para mostrarte qué tan
        cerca estás de acertar.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="C" status="correct" />
        <Cell value="H" />
        <Cell value="O" />
        <Cell value="R" />
        <Cell value="O" />
      </div>
      <p className="text-sm text-gray-700 dark:text-gray-300">
        La palabra contiene la letra C y está en el lugar correcto.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="C" />
        <Cell value="H" />
        <Cell value="A" status="present" />
        <Cell value="P" />
        <Cell value="E" />
      </div>
      <p className="text-sm text-gray-700 dark:text-gray-300">
        La palabra contiene la letra A pero está en el lugar incorrecto.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="F" />
        <Cell value="I" status="absent" />
        <Cell value="E" />
        <Cell value="R" />
        <Cell value="O" />
      </div>
      <p className="text-sm text-gray-700 dark:text-gray-300">
        La palabra no contiene la letra I.
      </p>

      <p className="mt-6 text-sm text-gray-700 dark:text-gray-300">
        En Tucudle, la palabra del día es una relacionada con Tucumán. Puede
        ser del <b>lunfardo</b>, de uso popular en distintas generaciones, <b>lugares de la provincia</b>,
        e incluso ser <b>una cosa o figura icónica</b>!
      </p>
    </BaseModal>
  )
}